export const FORM_ELEMENT_TYPES = {
    SELECT_INPUT:"SELECT",
    TEXT_INPUT:"TEXTBOX",
    HTML_EDITOR:"HTML_EDITOR",
    TEXTAREA: "TEXTAREA",
    CHECKBOX_INPUT: "CHECKBOX",
	SWITCH:"SWITCH",
	RADIO_INPUT:"RADIO_INPUT",
	FILE_UPLOAD:"FILE_UPLOAD",
	DATETIME_INPUT : "DATETIME_INPUT"
};

enum TOOL_SELECTION_TYPES {
	NEW=1,
	EXISTING=2,
	MAINTENANCE_POP_UP = 3,
	PORTAL_MAINTENANCE = 4
}

export const ENUMS = {
	TOOL_SELECTION_TYPES
};